import { render, staticRenderFns } from "./SurveyPageView.vue?vue&type=template&id=59f87a8a"
import script from "./SurveyPageView.vue?vue&type=script&lang=ts"
export * from "./SurveyPageView.vue?vue&type=script&lang=ts"
import style0 from "./SurveyPageView.vue?vue&type=style&index=0&id=59f87a8a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports